export default {"src":"/_next/static/media/calendar-header-icon.232f023c.svg","height":16,"width":16};